<style scoped>
.btn-edit {
  width: 25px;
  height: 30px;
  border: 1px solid gray;
  cursor: pointer;
  position: relative;
}
.btn-edit-icon {
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 12px;
}
</style>

<template>
  <div class="position-relative">
    <div class="row mb-3 justify-content-evenly border rounded-3 p-1">
      <button
        id="decrease"
        class="col-2 btn-edit bg-light border rounded-circle align-self-center"
        type="button"
        @click="decrease"
      >
        <i class="fa fa-minus p-0 btn-edit-icon"></i>
      </button>
      <input
        tabindex="0"
        class="col-4 input-1 text-center rounded mb-0 fs-5 input-banknote btn"
        style="border: 0px"
        value="0"
        v-bind:name="id"
        readonly
        role="button"
        data-bs-toggle="popover"
        data-bs-trigger="focus"
        data-bs-custom-class="bg-white"
        v-model="inputValue"
        @click="toggleNumberKeyBoard()"
      />
      <button
        id="increase"
        class="col-2 btn-edit bg-light border rounded-circle align-self-center"
        type="button"
        @click="increase"
      >
        <i class="fa fa-plus p-0 btn-edit-icon"></i>
      </button>
    </div>
    <input-number-keyborad></input-number-keyborad>
  </div>
</template>



<script>
export default {
  name: "ProductAmount",
  props: ["id", "step_prices", "amount_per_unit", "unit_price", "value"],
  data() {
    return {
      inputValue: 0,
      total: 0,
    };
  },
  mounted() {
    this.inputValue = this.value;
  },
  watch: {
    inputValue(newValue, oldValue) {
      if (this.id) {
        let idSplit = this.id.split("_");
        let number = idSplit[idSplit.length - 1];
        if (number[0] == "0") {
          number = parseFloat(number.slice(0, 1) + "." + number.slice(1, 3));
        }
        let value = newValue * number;
        this.total = value;
        let sumTotal = 0;
        this.$root.$children.forEach((item) => {
          sumTotal += item.total;
          this.$root.setTotal(sumTotal);
        });
        document.getElementById(`total-banknote-${this.id}`).innerHTML =
          value.toLocaleString("th-TH");
      }
    },
  },
  methods: {
    increase() {
      this.inputValue++;
      this.calStepPrices();
      document.getElementById("increase").blur();
    },
    decrease() {
      if (this.inputValue >= 1) {
        this.inputValue--;
      } else {
        this.inputValue = 0;
      }
      document.getElementById("decrease").blur();
      this.calStepPrices();
      //   console.log(this.inputValue);
    },
    getInputValue() {
      return this.inputValue;
    },
    setInputValue(value) {
      this.inputValue = value;
      this.calStepPrices();
    },
    toggleNumberKeyBoard() {
      this.$children[0].setIsOpen(!this.$children[0].getIsOpen());
      this.$children[0].getProductAmount();
    },
    calStepPrices() {
      let price;
      //   console.log(this.amount_per_unit);
      if (this.step_prices && this.step_prices.length > 0) {
        let step_prices = this.step_prices.slice().sort().reverse(); // high to low
        for (let index = 0; index < step_prices.length; index++) {
          if (this.amount_per_unit) {
            if (
              this.inputValue * this.amount_per_unit >=
              step_prices[index].step_amount
            ) {
              price = step_prices[index].step_price * this.amount_per_unit;
            }
          } else {
            if (this.inputValue >= step_prices[index].step_amount) {
              price = step_prices[index].step_price;
            }
          }
          if (!this.amount_per_unit) {
            if (
              this.inputValue < step_prices[step_prices.length - 1].step_amount
            ) {
              price = this.unit_price;
            }
          }
          if (price) {
            console.log(price);
            appCart.productChosen.price = parseFloat(price).toFixed(2);
            break;
          }
        }
      }
    },
  },
};
</script>

